<mat-tab-group (selectedTabChange)="tabClicked($event)" [(selectedIndex)]="ActiveTab" mat-stretch-tabs
    class="tab_group">
    <mat-tab label="ADD" *ngIf="persistenceService.get('addDisable') == 'true'">

        <form class="global-form" [formGroup]="productionSetUpForm" (ngSubmit)="onCostingSaveClick()"
            *ngIf="ActiveTab == persistenceService.get('addTabIndex')">
            <div class="custom_tab_body">
                <div class="row">
                    <div class="col-md-3 col-sm-12 col-12">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill" class="selectOption">

                                <mat-label>Product Name</mat-label>
                                <input class="global-input" type="text" matInput formControlName="productName" [matAutocomplete]="auto"
                                    (keyup)="onSearchProduct($event.target.value)">
                                <mat-autocomplete #auto="matAutocomplete"
                                    (optionSelected)='onSearchProductSelect($event.option.value)'>
                                    <mat-option *ngFor="let element of filteredOptions | async" [value]="element">
                                        <span style="color: black;font-size: 19px;">{{element.product_Name}}</span>
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-3 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill">

                                <mat-label>Product Price</mat-label>
                                <input class="global-input" matInput type="text" formControlName="price" id="number_align" readonly>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-3 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill">

                                <mat-label>Product Weight</mat-label>
                                <input class="global-input" matInput type="number" (keyup)="onChangeData($event.target, 'Weight')"
                                    (focusout)="onChangeDataFocusOut($event.target, 'Weight')" id="number_align"
                                    formControlName="weight" autocomplete="off" (focus)="$event.target.select()">
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-3 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill">

                                <mat-label>Product Unit</mat-label>
                                <input class="global-input" matInput type="text" formControlName="unit" readonly>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-4 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill">

                                <mat-label>Batch Qty</mat-label>
                                <input class="global-input" matInput type="number" (keyup)="onChangeData($event.target, 'BatchSize')"
                                    (focusout)="onChangeDataFocusOut($event.target, 'BatchSize')" id="number_align"
                                    formControlName="batchSize" autocomplete="off" (focus)="$event.target.select()">
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-4 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill">

                                <mat-label>Production Loss %</mat-label>
                                <input class="global-input" matInput type="number" (keyup)="onChangeData($event.target, 'Loss')"
                                    (focusout)="onChangeDataFocusOut($event.target, 'Loss')" id="number_align"
                                    formControlName="productionLoss" autocomplete="off"
                                    (focus)="$event.target.select()">
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-4 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill">

                                <mat-label>Production Overheads %</mat-label>
                                <input class="global-input" matInput type="number" (keyup)="onChangeData($event.target, 'Overhead')"
                                    (focusout)="onChangeDataFocusOut($event.target, 'Overhead')" id="number_align"
                                    formControlName="overheadLoss" autocomplete="off" (focus)="$event.target.select()">
                            </mat-form-field>
                        </mat-card>
                    </div>
                </div>
                <div style="overflow: scroll;">
                    <table class="mat-table">
                        <caption></caption>
                        <tr class="mat-header-row">
                            <th class="mat-header-cell" style="width: 100px"><span></span></th>
                            <th class="mat-header-cell">Material Cost</th>
                            <th class="mat-header-cell">Production Loss</th>
                            <th class="mat-header-cell">Overheads</th>
                            <th class="mat-header-cell">Packaging Cost</th>
                            <th class="mat-header-cell">Total Cost</th>
                            <th class="mat-header-cell">Weight</th>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell">Batch</td>
                            <td class="mat-cell">{{costCart[0].costOfMaterialBatch}}</td>
                            <td class="mat-cell">{{costCart[0].productionLoss}}</td>
                            <td class="mat-cell">{{costCart[0].overheadLoss}}</td>
                            <td class="mat-cell">{{costCart[0].costOfPackagingBatch}}</td>
                            <td class="mat-cell">{{costCart[0].overallCostBatch}}</td>
                            <td class="mat-cell">{{costCart[0].overallWeightBatch}}{{selectedUnit}}</td>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell">Unit</td>
                            <td class="mat-cell">{{costCart[1].costOfMaterialBatch}}</td>
                            <td class="mat-cell">{{costCart[1].productionLoss}}</td>
                            <td class="mat-cell">{{costCart[1].overheadLoss}}</td>
                            <td class="mat-cell">{{costCart[1].costOfPackagingBatch}}</td>
                            <td class="mat-cell">{{costCart[1].overallCostBatch}}</td>
                            <td class="mat-cell">{{costCart[1].overallWeightBatch}}{{selectedUnit}}</td>
                        </tr>
                    </table>
                </div>

                <!-- ========================= New Added ========================= -->

                <!-- <<<<<<<<================Raw Materials================>>>>>>> -->
                <div id="table-container-costing" formArrayName="rawMaterial">
                    <table class="mat-table" style="width: max-content !important; min-width: 100%">
                        <caption></caption>
                        <tr class="mat-header-row">
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> SL No </th>
                            <th scope="col" class="mat-header-cell" style="width: 20%;"> Raw Material Name </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Unit </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Qty </th>
                            <th scope="col" class="mat-header-cell" style="width: 20%;">
                                <mat-form-field appearance="fill" appearance="fill">

                                    <mat-label>Select Convert To Unit</mat-label>
                                    <mat-select panelClass="custom-select-panel" class="field-full-width table-header-select"
                                        (selectionChange)="onUnitSelect($event.value)"
                                        [formControl]="myControlConvUnit">
                                        <mat-option *ngFor="let c of unitList" [value]="c">
                                            {{c}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Conversion Factor </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Converted Qty </th>
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Rate </th>
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Amount </th>


                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Cancel </th>
                        </tr>
                        <tr class="mat-row" *ngFor="let element of rawMaterialFormArray.controls;
                                   let i = index;" style="height: 30px !important;">
                            <td class="mat-cell"> {{i+1}} </td>
                            <td class="mat-cell" [formGroupName]="i">

                                <mat-form-field appearance="fill" appearance="fill" class="selectOption">
                                    <input class="global-input" type="text" matInput formControlName="productName"
                                        [matAutocomplete]="autoRaw" (keyup)="onSearchRawMaterial($event.target.value)">
                                    <mat-autocomplete #autoRaw="matAutocomplete"
                                        (optionSelected)='onSearchRawMaterialSelect($event.option.value, i)'>
                                        <mat-option *ngFor="let element of filteredOptionsRawMaterial | async"
                                            [value]="element">
                                            <span style="color: black;font-size: 19px;">{{element.product_Name}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>

                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="text" id="text_align" formControlName="unit">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number" (keyup)="onRawMaterialQtyChange($event.target, i)"
                                        (focusout)="onRawMaterialQtyChangeFocusout($event.target, i)" id="number_align"
                                        formControlName="qty" autocomplete="off" (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" readonly matInput type="text" id="text_align" [value]="selectedUnit">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number"
                                        (keyup)="onRawMaterialConvsFactChange($event.target, i)"
                                        (focusout)="onRawMaterialConvsFactChangeFocusout($event.target, i)"
                                        formControlName="conversionFactor" autocomplete="off" id="number_align"
                                        (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number" (keyup)="onRawMaterialConvQtyChange($event.target, i)"
                                        (focusout)="onRawMaterialConvQtyChangeFocusout($event.target, i)"
                                        formControlName="convertedQuantity" autocomplete="off" id="number_align"
                                        (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="number" id="number_align" formControlName="rate">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="number" id="number_align" formControlName="amount">
                                </mat-form-field>
                            </td>

                            <td class="mat-cell">
                                <mat-icon (click)="onRawMaterialRemoveRowClick(i)"> cancel </mat-icon>
                            </td>
                        </tr>
                        <tfoot>
                            <tr class="costing-table-footer">
                                <td> Total: </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td id="number_align">{{rawMaterialConvertedQty}}</td>
                                <td></td>
                                <td id="number_align">{{totalRawMaterialAmount}}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div style="display: flex;">
                    <mat-card-actions>
                        <button class="global-button" type="button" id="btmBtn" (click)="onRawMaterialAddRowClick()">
                            ADD<mat-icon class="icon-style">add</mat-icon>
                        </button>
                    </mat-card-actions>

                    <mat-card-actions>
                        <button class="global-button" type="button" id="btmBtn" (click)="onRawMaterialResetClick()">
                            RESET<mat-icon class="icon-style">settings_backup_restore</mat-icon>
                        </button>
                    </mat-card-actions>
                </div>

                <!-- <<<<<<<================= Finished material =============>>>>>> -->
                <div id="table-container-costing" formArrayName="finishedMaterial">
                    <table class="mat-table" style="width: max-content !important; min-width: 100%">
                        <caption></caption>
                        <tr class="mat-header-row">
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> SL No </th>
                            <th scope="col" class="mat-header-cell" style="width: 20%;">Finished Material Name
                            </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Unit </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Qty </th>
                            <th scope="col" class="mat-header-cell" style="width: 20%;">
                                <mat-form-field appearance="fill" appearance="fill">

                                    <mat-label>Select Convert To Unit</mat-label>
                                    <mat-select panelClass="custom-select-panel" class="field-full-width" (selectionChange)="onUnitSelect($event.value)"
                                        [formControl]="myControlConvUnit">
                                        <mat-option *ngFor="let c of unitList" [value]="c">
                                            {{c}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Conversion Factor </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Converted Qty </th>
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Rate </th>
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Amount </th>


                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Cancel </th>
                        </tr>
                        <tr class="mat-row" *ngFor="let element of finishedMaterialFormArray.controls;
                                   let i = index;" style="height: 30px !important;">
                            <td class="mat-cell"> {{i+1}} </td>
                            <td class="mat-cell" [formGroupName]="i">

                                <mat-form-field appearance="fill" appearance="fill" class="selectOption">
                                    <input class="global-input" type="text" matInput formControlName="productName" [matAutocomplete]="autoFM"
                                        (keyup)="onSearchFinishedMaterial($event.target.value)">
                                    <mat-autocomplete #autoFM="matAutocomplete"
                                        (optionSelected)='onSearchFinishedMaterialSelect($event.option.value, i)'>
                                        <mat-option *ngFor="let element of filteredOptionsFinishedMaterial | async"
                                            [value]="element">
                                            <span style="color: black;font-size: 19px;">{{element.product_Name}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>

                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="text" id="text_align" formControlName="unit">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number"
                                        (keyup)="onFinishedMaterialQtyChange($event.target, i)"
                                        (focusout)="onFinishedMaterialQtyChangeFocusout($event.target, i)"
                                        id="number_align" formControlName="qty" autocomplete="off"
                                        (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" readonly matInput type="text" id="text_align" [value]="selectedUnit">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number"
                                        (keyup)="onFinishedMaterialConvsFactChange($event.target, i)"
                                        (focusout)="onFinishedMaterialConvsFactChangeFocusout($event.target, i)"
                                        formControlName="conversionFactor" autocomplete="off" id="number_align"
                                        (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number"
                                        (keyup)="onFinishedMaterialConvQtyChange($event.target, i)"
                                        (focusout)="onFinishedMaterialConvQtyChangeFocusout($event.target, i)"
                                        formControlName="convertedQuantity" autocomplete="off" id="number_align"
                                        (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="number" id="number_align" formControlName="rate">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="number" id="number_align" formControlName="amount">
                                </mat-form-field>
                            </td>

                            <td class="mat-cell">
                                <mat-icon (click)="onFinishedMaterialRemoveRowClick(i)"> cancel </mat-icon>
                            </td>
                        </tr>
                        <tfoot>
                            <tr class="costing-table-footer">
                                <td> Total: </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td id="number_align">{{finishedMaterialConvertedQty}}</td>
                                <td></td>
                                <td id="number_align">{{totalFinishedMaterialAmount}}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div style="display: flex;">
                    <mat-card-actions>
                        <button class="global-button" type="button" id="btmBtn" (click)="onFinishedMaterialAddRowClick()">
                            ADD<mat-icon class="icon-style">add</mat-icon>
                        </button>
                    </mat-card-actions>

                    <mat-card-actions>
                        <button class="global-button" type="button" id="btmBtn" (click)="onFinishedMaterialResetClick()">
                            RESET<mat-icon class="icon-style">settings_backup_restore</mat-icon>
                        </button>
                    </mat-card-actions>
                </div>
                <!-- <<<<<<<=================Semi-Finished material =============>>>>>> -->
                <div id="table-container-costing" formArrayName="semiFinishedMaterial">
                    <table class="mat-table" style="width: max-content !important; min-width: 100%">
                        <caption></caption>
                        <tr class="mat-header-row">
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> SL No </th>
                            <th scope="col" class="mat-header-cell" style="width: 20%;">Semi Finished Material Name
                            </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Unit </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Qty </th>
                            <th scope="col" class="mat-header-cell" style="width: 20%;">
                                <mat-form-field appearance="fill" appearance="fill">

                                    <mat-label>Select Convert To Unit</mat-label>
                                    <mat-select panelClass="custom-select-panel" class="field-full-width" (selectionChange)="onUnitSelect($event.value)"
                                        [formControl]="myControlConvUnit">
                                        <mat-option *ngFor="let c of unitList" [value]="c">
                                            {{c}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Conversion Factor </th>
                            <th scope="col" class="mat-header-cell" style="width: 10%;"> Converted Qty </th>
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Rate </th>
                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Amount </th>


                            <th scope="col" class="mat-header-cell" style="width: 5%;"> Cancel </th>
                        </tr>
                        <tr class="mat-row" *ngFor="let element of semiFinishedMaterialFormArray.controls;
                   let i = index;" style="height: 30px !important;">
                            <td class="mat-cell"> {{i+1}} </td>
                            <td class="mat-cell" [formGroupName]="i">

                                <mat-form-field appearance="fill" appearance="fill" class="selectOption">
                                    <input class="global-input" type="text" matInput formControlName="productName"
                                        [matAutocomplete]="autoSFM"
                                        (keyup)="onSearchSemiFinishedMaterial($event.target.value)">
                                    <mat-autocomplete #autoSFM="matAutocomplete"
                                        (optionSelected)='onSearchSemiFinishedMaterialSelect($event.option.value, i)'>
                                        <mat-option *ngFor="let element of filteredOptionsSemiFinishedMaterial | async"
                                            [value]="element">
                                            <span style="color: black;font-size: 19px;">{{element.product_Name}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>

                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="text" id="text_align" formControlName="unit">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number"
                                        (keyup)="onSemiFinishedMaterialQtyChange($event.target, i)"
                                        (focusout)="onSemiFinishedMaterialQtyChangeFocusout($event.target, i)"
                                        id="number_align" formControlName="qty" autocomplete="off"
                                        (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" readonly matInput type="text" id="text_align" [value]="selectedUnit">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number"
                                        (keyup)="onSemiFinishedMaterialConvsFactChange($event.target, i)"
                                        (focusout)="onSemiFinishedMaterialConvsFactChangeFocusout($event.target, i)"
                                        formControlName="conversionFactor" autocomplete="off" id="number_align"
                                        (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number"
                                        (keyup)="onSemiFinishedMaterialConvQtyChange($event.target, i)"
                                        (focusout)="onSemiFinishedMaterialConvQtyChangeFocusout($event.target, i)"
                                        formControlName="convertedQuantity" autocomplete="off" id="number_align"
                                        (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="number" id="number_align" formControlName="rate">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="number" id="number_align" formControlName="amount">
                                </mat-form-field>
                            </td>

                            <td class="mat-cell">
                                <mat-icon (click)="onSemiFinishedMaterialRemoveRowClick(i)"> cancel </mat-icon>
                            </td>
                        </tr>
                        <tfoot>
                            <tr class="costing-table-footer">
                                <td> Total: </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td id="number_align">{{semiFinishedMaterialConvertedQty}}</td>
                                <td></td>
                                <td id="number_align">{{totalSemiFinishedMaterialAmount}}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div style="display: flex;">
                    <mat-card-actions>
                        <button class="global-button" type="button" id="btmBtn" (click)="onSemiFinishedMaterialAddRowClick()">
                            ADD<mat-icon class="icon-style">add</mat-icon>
                        </button>
                    </mat-card-actions>

                    <mat-card-actions>
                        <button class="global-button" type="button" id="btmBtn" (click)="onSemiFinishedMaterialResetClick()">
                            RESET<mat-icon class="icon-style">settings_backup_restore</mat-icon>
                        </button>
                    </mat-card-actions>
                </div>
                <!-- ========================= New Added End========================= -->

                <div id="table-container-costing" formArrayName="packagingMaterial">
                    <table class="mat-table" style="width: max-content !important; min-width: 100%">
                        <caption></caption>
                        <tr class="mat-header-row">
                            <th scope="col" class="mat-header-cell"> SL No </th>
                            <th scope="col" class="mat-header-cell"> Packaging Material Name </th>
                            <th scope="col" class="mat-header-cell"> Unit </th>
                            <th scope="col" class="mat-header-cell"> Qty </th>
                            <th scope="col" class="mat-header-cell"> Rate </th>
                            <th scope="col" class="mat-header-cell"> Amount </th>


                            <th scope="col" class="mat-header-cell"> Cancel </th>
                        </tr>
                        <tr class="mat-row" *ngFor="let element of packagingMaterialFormArray.controls;
                                   let i = index;" style="height: 30px !important;">
                            <td class="mat-cell"> {{i+1}} </td>
                            <td class="mat-cell">
                                <mat-form-field appearance="fill" appearance="fill" class="selectOption"
                                    [formGroupName]="i">
                                    <input class="global-input" type="text" matInput formControlName="productName" [matAutocomplete]="auto"
                                        (keyup)="onSearchProductPackaging($event.target.value)">
                                    <mat-autocomplete #auto="matAutocomplete"
                                        (optionSelected)='onSearchProductSelectPackaging($event.option.value, i)'>
                                        <mat-option *ngFor="let element of filteredOptionsPackaging | async"
                                            [value]="element">
                                            <span style="color: black;font-size: 19px;">{{element.product_Name}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput readonly type="text" id="text_align" formControlName="unit">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number" (keyup)="onPackageQtyChange($event.target, i)"
                                        (focusout)="onPackageQtyChangeFocusout($event.target, i)" id="number_align"
                                        formControlName="qty" autocomplete="off" (focus)="$event.target.select()">
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number" id="number_align" formControlName="rate" readonly>
                                </mat-form-field>
                            </td>
                            <td class="mat-cell" [formGroupName]="i">
                                <mat-form-field appearance="fill" appearance="fill">
                                    <input class="global-input" matInput type="number" id="number_align" formControlName="amount" readonly>
                                </mat-form-field>
                            </td>

                            <td class="mat-cell">
                                <mat-icon (click)="onPackagingMaterialRemoveRowClick(i)"> cancel </mat-icon>
                            </td>
                        </tr>
                        <tfoot>
                            <tr class="costing-table-footer">
                                <td> Total: </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td id="number_align"> {{totalPackagingMaterialAmount}}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div style="display: flex;">
                    <mat-card-actions>
                        <button class="global-button" type="button" id="btmBtn" (click)="onPackagingMaterialAddRowClick()">
                            ADD<mat-icon class="icon-style">add</mat-icon>
                        </button>
                    </mat-card-actions>

                    <mat-card-actions>
                        <button class="global-button" type="button" id="btmBtn" (click)="onPackagingMaterialResetClick()">
                            RESET<mat-icon class="icon-style">settings_backup_restore</mat-icon>
                        </button>
                    </mat-card-actions>
                </div>

            </div>

            <div class="custom_sticky_footer">
                <div class="flex-100">
                    <button class="global-button" type="submit" id="btnn" [keyboardShortcut]="saveShortcut">
                        <mat-icon class="footer_icon_style">save</mat-icon>
                        <br>
                        <span class="red_color">S</span>UBMIT
                    </button>
                </div>
            </div>
        </form>
    </mat-tab>

    <!-- ====================================================VIEW===================================================== -->

    <mat-tab label="VIEW" *ngIf="persistenceService.get('viewDisable') == 'true'">
        <form class="global-form" [formGroup]="viewSetUpForm" (ngSubmit)="onViewClick(true)"
            *ngIf="ActiveTab == persistenceService.get('viewTabIndex')">
            <div class="custom_tab_body">
                <div class="row">
                    <div class="col-md-3 col-sm-12 col-12">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill">

                                <mat-label>Search</mat-label>
                                <input class="global-input" matInput type="text" (keyup)="searchView($event)">
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-3 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" appearance="fill" class="field-full-width">

                                <mat-label>Company</mat-label>
                                <mat-select panelClass="custom-select-panel" class="field-full-width" [value]="companyName">
                                    <mat-option [value]="companyName">
                                        {{companyName}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-3 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Parent Location</mat-label>
                                <mat-select panelClass="custom-select-panel" class="field-full-width" [value]="parentLocationName">
                                    <mat-option [value]="parentLocationName">
                                        {{parentLocationName}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-3 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="field-full-width">

                                <mat-label>Costing Location</mat-label>
                                <mat-select panelClass="custom-select-panel" formControlName="costingLocation" multiple
                                    (openedChange)="onLocationSelectView($event)"
                                    (selectionChange)="onLocationSelectionChange($event.value)">
                                    
<div *ngIf="locationList.length > 1" class="search_box_wrapper">


                                        <mat-label>Search Location</mat-label>
                                        <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
                                            (keyup)="searchLocationFromList($event.target.value)" autocomplete="off">
                                    
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="locationList.length > 1" value="0" (click)="allLocationSelect()"
                                        class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelectedLocIds.length}} of {{locationList.length}}) </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let location of filteredLocationList"
                                            [value]="location.refNo"
                                            [ngClass]="location.status == 'Inactive' ? 'red' : '' ">
                                            {{location.locationName}}</mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-3 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="selectOption">

                                <mat-label>Select Inventory Type</mat-label>
                                <mat-select panelClass="custom-select-panel" multiple (openedChange)="onViewInventorySelect($event)"
                                    formControlName="inventoryType"
                                    (selectionChange)="onViewInventorySelectionChange($event.value)">
                                    
<div *ngIf="inventoryTypeList.length > 1" class="search_box_wrapper">


                                        <mat-label>Search InventoryType</mat-label>
                                        <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
                                            (keyup)="searchInventoryType($event.target.value)" autocomplete="off">
                                    
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="inventoryTypeList.length > 1" value="0"
                                        (click)="allInventoryTypeSelect()" class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelecteViewInventory.length}} of {{inventoryTypeList.length}})
                                        </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let c of filteredInventoryTypeList" [value]="c.refNo">
                                            {{c.inventoryTypeName}}
                                        </mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-3 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="selectOption">

                                <mat-label>Select Product Matrix</mat-label>
                                <mat-select panelClass="custom-select-panel" multiple (openedChange)="onViewMatrixSelect($event)"
                                    formControlName="matrixCode"
                                    (selectionChange)="onViewMatrixSelectionChange($event.value)">
                                    
<div *ngIf="matrixList.length > 1" class="search_box_wrapper">


                                        <mat-label>Search Product Matrix</mat-label>
                                        <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
                                            (keyup)="searchMatrix($event.target.value)" autocomplete="off">
                                    
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="matrixList.length > 1" value="0" (click)="allMatrixSelect()"
                                        class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelecteViewMatrix.length}} of {{matrixList.length}}) </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let c of filteredMatrixList" [value]="c.refNo">
                                            {{c.productMatrixName}}
                                        </mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-2 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="selectOption">

                                <mat-label>Select Product Group</mat-label>
                                <mat-select panelClass="custom-select-panel" multiple (openedChange)="onViewGroupSelect($event)"
                                    formControlName="groupCode"
                                    (selectionChange)="onViewGroupSelectionChange($event.value)">
                                    
<div *ngIf="groupList.length > 1" class="search_box_wrapper">


                                        <mat-label>Search Product Group</mat-label>
                                        <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
                                            (keyup)="searchProductGroup($event.target.value)" autocomplete="off">
                                    
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="groupList.length > 1" value="0" (click)="allProductGroupSelect()"
                                        class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelecteViewGroup.length}} of {{groupList.length}}) </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let c of filteredProductGroupTypeList" [value]="c[0]">
                                            {{c[1]}}
                                        </mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-2 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="selectOption">

                                <mat-label>Select Product SubGroup</mat-label>
                                <mat-select panelClass="custom-select-panel" multiple (openedChange)="onViewSubGroupSelect($event.value)"
                                    formControlName="subGroupCode"
                                    (selectionChange)="onViewSubGroupSelectionChange($event.value)">
                                    
<div *ngIf="subGroupList.length > 1" class="search_box_wrapper">


                                        <mat-label>Search ProductSubgroup</mat-label>
                                        <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
                                            (keyup)="searchSubGroupList($event.target.value)" autocomplete="off">
                                    
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="subGroupList.length > 1" value="0"
                                        (click)="allProductSubGroupSelect()" class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelectViewSubGroup.length}} of {{subGroupList.length}}) </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let c of filteredProductSubGroupTypeList" [value]="c[0]">
                                            {{c[1]}}
                                        </mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-2 col-sm-6 col-6">
                        <button type="submit" class="new_btnStyle global-button" [keyboardShortcut]="viewbtnShortcut"><span
                                class="red_color">V</span>IEW<mat-icon class="icon-style">search</mat-icon>
                        </button>
                    </div>

                </div>

                <div class="shipping_box">
                    <div class="filter_toolbar">
                        <mat-form-field appearance="fill" appearance="fill" class="flex-3">
                            <mat-icon class="white_icon" matTooltip="Filter Columns(Alt+i)">filter_list</mat-icon>
                            <mat-select panelClass="custom-select-panel" multiple (selectionChange)="onColumnSelect($event.value, true)"
                                ngClass="e-caret-hide" class="filterListSelect" [value]="selectedColumns"
                                [KeyboardShortcut]="tablefilterShortcut">
                                <mat-option *ngFor="let column of optionalColumns" [value]="column">
                                    {{column}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div id="view-table-div-container">
                    <table mat-table class="mat-elevation-z8" [dataSource]="dataSourceView" multiTemplateDataRows
                        matSort (matSortChange)="announceSortChange($event)">
                        <caption></caption>

                        <ng-container matColumnDef="material">
                            <th scope="col" mat-header-cell *matHeaderCellDef
                                (click)="allExpandMaterial = !allExpandMaterial">
                                <mat-icon *ngIf="allExpandMaterial == true" style="top: 3px !important;">
                                    indeterminate_check_box
                                </mat-icon>
                                <mat-icon *ngIf="allExpandMaterial == false" style="top: 3px !important;">add_box
                                </mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element"
                                (click)="element.isExpandedMaterial=!element.isExpandedMaterial">
                                <div *ngIf="element.isExpandedMaterial">
                                    <mat-icon>indeterminate_check_box</mat-icon>
                                </div>
                                <div *ngIf="!element.isExpandedMaterial">
                                    <mat-icon>add_box</mat-icon>
                                </div>
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="packaging">
                            <th scope="col" mat-header-cell *matHeaderCellDef
                                (click)="allExpandPackaging = !allExpandPackaging">
                                <mat-icon *ngIf="allExpandPackaging == true" style="top: 3px !important;">
                                    indeterminate_check_box
                                </mat-icon>
                                <mat-icon *ngIf="allExpandPackaging == false" style="top: 3px !important;">add_box
                                </mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element"
                                (click)="element.isExpandedPackaging=!element.isExpandedPackaging">
                                <div *ngIf="element.isExpandedPackaging">
                                    <mat-icon>indeterminate_check_box</mat-icon>
                                </div>
                                <div *ngIf="!element.isExpandedPackaging">
                                    <mat-icon>add_box</mat-icon>
                                </div>
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="process">
                            <th scope="col" mat-header-cell *matHeaderCellDef
                                (click)="allExpandProcess = !allExpandProcess">
                                <mat-icon *ngIf="allExpandProcess == true" style="top: 3px !important;">
                                    indeterminate_check_box
                                </mat-icon>
                                <mat-icon *ngIf="allExpandProcess == false" style="top: 3px !important;">add_box
                                </mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element"
                                (click)="element.isExpandedProcess=!element.isExpandedProcess">
                                <div *ngIf="element.isExpandedProcess">
                                    <mat-icon>indeterminate_check_box</mat-icon>
                                </div>
                                <div *ngIf="!element.isExpandedProcess">
                                    <mat-icon>add_box</mat-icon>
                                </div>
                            </td>
                        </ng-container> -->

                        <ng-container matColumnDef="fromLocation">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>From Location</th>
                            <td mat-cell *matCellDef="let element" id="text_align">
                                {{element.fromLocation?.locationName}}
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="transactionNo">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Transaction No</th>
                            <td mat-cell *matCellDef="let element" id="text_align"> {{element.refNo}}</td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="byUser">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>By User</th>
                            <td mat-cell *matCellDef="let element" id="text_align">{{element.user.user_Name}} </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="date">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Date</th>
                            <td mat-cell *matCellDef="let element" id="text_align">{{element.date | date :
                                constant.viewDateFormat_DMYHMS}}
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="productName">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Product Name</th>
                            <td mat-cell *matCellDef="let element" id="text_align">
                                {{element.productDetail?.product_Name}}
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="price">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Product Price</th>
                            <td mat-cell *matCellDef="let element" id="number_align">
                                {{element.productDetail?.sale_Price}}
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="weight">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Product Weight</th>
                            <td mat-cell *matCellDef="let element" id="text_align">
                                {{element.weight}} {{element.productDetail?.product_Unit}}
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="batchSize">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Batch Size</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.batchSize}} </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="costOfMaterialBatch">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Cost Of Material Batch
                            </th>
                            <td mat-cell *matCellDef="let element" id="number_align">
                                {{element.costOfMaterialBatch}}</td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="costOfPackagingBatch">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Cost Of Packaging Batch
                            </th>
                            <td mat-cell *matCellDef="let element" id="number_align">
                                {{element.costOfPackagingBatch}}
                            </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="productionLoss">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Production Loss(%)</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.productionLoss}} </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="overheadLoss">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Overhead Loss(%)</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.overheadLoss}} </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="overallCostBatch">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Total Batch Cost</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.overallCostBatch}} </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="totalMaterialQty">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Total Material Qty</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.totalMaterialQty}} </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;" id="number_align">
                                {{viewTotalMaterialQty}} </td>
                        </ng-container>

                        <ng-container matColumnDef="totalPackagingQty">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Total Packaging Qty</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.totalPackagingQty}} </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="convertedQty">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Converted Batch Qty</th>
                            <td mat-cell *matCellDef="let element" id="text_align">{{element.totalTime}}
                                {{element.overallWeightBatch + ' ' + element.convertToUnit}}</td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container>

                        <ng-container matColumnDef="expandedMaterial">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="viewTableColumns.length">
                                <div class="example-element-detail"
                                    [@detailExpand]="element.isExpandedMaterial ? 'expanded' : 'collapsed'"
                                    [@detailExpand]="allExpandMaterial ? 'expanded' : 'collapsed'">
                                    <div class="example-element-description">
                                        <mat-card appearance="outlined" style="width: max-content ;">
                                            <fieldset class="field_set" id="security_fieldset">

                                                <legend class="legend" style="text-align: start;">Product Costing
                                                    Material Details:
                                                </legend>
                                                <div class="costing_detailstable-style">
                                                    <table class="mat-table" style="width: max-content !important;
                                                     min-width: 30%; margin: 4px;">
                                                        <caption>Raw Material</caption>
                                                        <tr class="mat-header-row"
                                                            style="height: max-content !important ;">
                                                            <th scope="col" class="mat-header-cell"> Product Name </th>
                                                            <th scope="col" class="mat-header-cell"> Rate </th>
                                                            <th scope="col" class="mat-header-cell"> Quantity </th>
                                                            <th scope="col" class="mat-header-cell"> Converted Quantity
                                                            </th>
                                                            <th scope="col" class="mat-header-cell"> Amount </th>
                                                        </tr>

                                                        <tr class="mat-row"
                                                            *ngFor="let data of element.productCostingRawMaterials ">
                                                            <td class="mat-cell" id="text_align">
                                                                {{data.productDetail?.product_Name}} </td>
                                                            <td class="mat-cell" id="number_align"> {{data.rate}} </td>
                                                            <td class="mat-cell" id="number_align"> {{data.qty}} </td>
                                                            <td class="mat-cell" id="number_align">
                                                                {{(data.conversionFactor * data.qty) + ' ' +
                                                                element.convertToUnit}} </td>
                                                            <td class="mat-cell" id="number_align"> {{(data.rate *
                                                                data.qty) | commaFormat: constant.roundOffFormat}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <table class="mat-table" style="width: max-content !important;
                                                     min-width: 30%; margin: 4px;">
                                                        <caption>Finished Material</caption>
                                                        <tr class="mat-header-row"
                                                            style="height: max-content !important ;">
                                                            <th scope="col" class="mat-header-cell"> Product Name </th>
                                                            <th scope="col" class="mat-header-cell"> Rate </th>
                                                            <th scope="col" class="mat-header-cell"> Quantity </th>
                                                            <th scope="col" class="mat-header-cell"> Converted Quantity
                                                            </th>
                                                            <th scope="col" class="mat-header-cell"> Amount </th>
                                                        </tr>

                                                        <tr class="mat-row"
                                                            *ngFor="let data of element.productCostingFinishedMaterials ">
                                                            <td class="mat-cell" id="text_align">
                                                                {{data.productDetail?.product_Name}} </td>
                                                            <td class="mat-cell" id="number_align"> {{data.rate}} </td>
                                                            <td class="mat-cell" id="number_align"> {{data.qty}} </td>
                                                            <td class="mat-cell" id="number_align">
                                                                {{(data.conversionFactor * data.qty) +' ' +
                                                                element.convertToUnit}} </td>
                                                            <td class="mat-cell" id="number_align"> {{(data.rate *
                                                                data.qty) | commaFormat: constant.roundOffFormat}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <table class="mat-table" style="width: max-content !important;
                                                     min-width: 30%; margin: 4px;">
                                                        <caption>Semi Finished Material</caption>
                                                        <tr class="mat-header-row"
                                                            style="height: max-content !important ;">
                                                            <th scope="col" class="mat-header-cell"> Product Name </th>
                                                            <th scope="col" class="mat-header-cell"> Rate </th>
                                                            <th scope="col" class="mat-header-cell"> Quantity </th>
                                                            <th scope="col" class="mat-header-cell"> Converted Quantity
                                                            </th>
                                                            <th scope="col" class="mat-header-cell"> Amount </th>
                                                        </tr>

                                                        <tr class="mat-row"
                                                            *ngFor="let data of element.productCostingSemiFinishedMaterials ">
                                                            <td class="mat-cell" id="text_align">
                                                                {{data.productDetail?.product_Name}} </td>
                                                            <td class="mat-cell" id="number_align"> {{data.rate}} </td>
                                                            <td class="mat-cell" id="number_align"> {{data.qty}} </td>
                                                            <td class="mat-cell" id="number_align">
                                                                {{(data.conversionFactor * data.qty) +' ' +
                                                                element.convertToUnit}} </td>
                                                            <td class="mat-cell" id="number_align"> {{(data.rate *
                                                                data.qty) | commaFormat: constant.roundOffFormat}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </fieldset>
                                        </mat-card>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="expandedPackaging">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="viewTableColumns.length">
                                <div class="example-element-detail"
                                    [@detailExpand]="element.isExpandedPackaging ? 'expanded' : 'collapsed'"
                                    [@detailExpand]="allExpandPackaging ? 'expanded' : 'collapsed'">
                                    <div class="example-element-description">
                                        <mat-card appearance="outlined" style="width: max-content ;">
                                            <fieldset class="field_set" id="security_fieldset">

                                                <legend class="legend" style="text-align: start;">Product Costing
                                                    Packaging Details:
                                                </legend>
                                                <table class="mat-table" style="width: max-content !important;">
                                                    <caption></caption>
                                                    <tr class="mat-header-row" style="height: max-content !important ;">
                                                        <th scope="col" class="mat-header-cell"> Product Name </th>
                                                        <th scope="col" class="mat-header-cell"> Rate </th>
                                                        <th scope="col" class="mat-header-cell"> Quantity </th>
                                                        <th scope="col" class="mat-header-cell"> Amount </th>
                                                    </tr>

                                                    <tr class="mat-row"
                                                        *ngFor="let data of element.productCostingPackagings ">
                                                        <td class="mat-cell" id="text_align">
                                                            {{data.productDetail?.product_Name}} </td>
                                                        <td class="mat-cell" id="number_align"> {{data.rate}} </td>
                                                        <td class="mat-cell" id="number_align"> {{data.qty}} </td>
                                                        <td class="mat-cell" id="number_align"> {{(data.rate * data.qty)
                                                            | commaFormat: constant.roundOffFormat}}
                                                        </td>
                                                    </tr>
                                                </table>

                                            </fieldset>
                                        </mat-card>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="expandedProcess">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="viewTableColumns.length">
                                <div class="example-element-detail"
                                    [@detailExpand]="element.isExpandedProcess ? 'expanded' : 'collapsed'"
                                    [@detailExpand]="allExpandProcess ? 'expanded' : 'collapsed'">
                                    <div class="example-element-description">
                                        <mat-card style="width: max-content ;">
                                            <fieldset class="field_set" id="security_fieldset">

                                                <legend class="legend" style="text-align: start;">Product Process
                                                    Details:
                                                </legend>
                                                <table class="mat-table" style="width: max-content !important;">
                                                    <caption></caption>
                                                    <tr class="mat-header-row" style="height: max-content !important ;">
                                                        <th scope="col" class="mat-header-cell"> Process Name </th>
                                                        <th scope="col" class="mat-header-cell"> Duration </th>
                                                    </tr>

                                                    <tr class="mat-row"
                                                        *ngFor="let data of element.productCostingProcess ">
                                                        <td class="mat-cell" id="text_align"> {{data.processName}}
                                                        </td>
                                                        <td class="mat-cell" id="text_align"> {{data.duration}}
                                                            {{element.durationType}} </td>
                                                    </tr>
                                                </table>

                                            </fieldset>
                                        </mat-card>
                                    </div>
                                </div>
                            </td>
                        </ng-container> -->

                        <tr mat-header-row *matHeaderRowDef="viewTableColumns; sticky: true"></tr>
                        <tr id="expTableRowHeight" mat-row *matRowDef="let element; columns: viewTableColumns;"
                            [class.example-expanded-row]="element.isExpandedMaterial">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedMaterial']" class="example-detail-row"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedPackaging']" class="example-detail-row">
                        </tr>
                        <tr mat-footer-row *matFooterRowDef="viewTableColumns; sticky: true"></tr>
                        <!-- <tr mat-row *matRowDef="let row; columns: ['expandedProcess']" class="example-detail-row"></tr> -->
                    </table>
                    <mat-paginator #paginator class="mat-paginator-custom" [length]="length" [pageSize]="pageSize"
                        (page)="pageEvent = handleViewPage($event)">
                    </mat-paginator>
                </div>
            </div>

            <div class="custom_sticky_footer">
                <div class="flex-100">
                    <button class="global-button" id="btnn" type="button" (click)="onExportClick()" [disabled]="viewDataTempList.length == 0"
                        [keyboardShortcut]="exportShortcut">
                        <mat-icon class="footer_icon_style">cloud_upload</mat-icon>
                        <br>
                        E<span class="red_color">X</span>PORT
                    </button>
                </div>
            </div>
        </form>
    </mat-tab>

    <!-- =================================================DELETE================================================ -->

    <mat-tab label="DELETE" *ngIf="persistenceService.get('cancelDisable') == 'true'">
        <form class="global-form" [formGroup]="deleteSetUpForm" (ngSubmit)="onViewClickForDelete(true)"
            *ngIf="ActiveTab == persistenceService.get('editTabIndex')">
            <div class="custom_tab_body">
                <div class="row">
                    <div class="col-md-2 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill">
                                <mat-label>Search</mat-label>
                                <input class="global-input" matInput type="text" (keyup)="searchDelete($event)">
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-2 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="selectOption">

                                <mat-label>Select Inventory Type</mat-label>
                                <mat-select panelClass="custom-select-panel" multiple (openedChange)="onInventorySelectForDelete($event.value)"
                                    formControlName="inventoryType"
                                    (selectionChange)="onDeltInventorySelectionChange($event.value)">
                                    <div *ngIf="locationList.length > 1" class="search_select_container">
    <mat-label>Search Location</mat-label>
    <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
           (input)="searchLocationFromList($event.target.value)"
           autocomplete="off">
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="inventoryTypeList.length > 1" value="0"
                                        (click)="allInventoryDelTypeSelect()" class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelectInventoryForDelt.length}} of {{inventoryTypeList.length}})
                                        </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let c of filteredDelInventoryTypeList" [value]="c.refNo">
                                            {{c.inventoryTypeName}}
                                        </mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-2 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="selectOption">

                                <mat-label>Product Matrix</mat-label>
                                <mat-select panelClass="custom-select-panel" multiple (openedChange)="onMatrixSelectForDelete($event.value)"
                                    formControlName="matrixCode"
                                    (selectionChange)="onDeltMatrixSelectionChange($event.value)">
                                    <div *ngIf="locationList.length > 1" class="search_select_container">
    <mat-label>Search Location</mat-label>
    <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
           (input)="searchLocationFromList($event.target.value)"
           autocomplete="off">
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="matrixListForDelete.length > 1" value="0"
                                        (click)="allMatrixDelTypeSelect()" class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelectedMatrixForDelt.length}} of {{matrixListForDelete.length}})
                                        </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let c of filteredDelMatrixTypeList" [value]="c.refNo">
                                            {{c.productMatrixName}}
                                        </mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-2 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="selectOption">

                                <mat-label>Product Group</mat-label>
                                <mat-select panelClass="custom-select-panel" multiple (openedChange)="onGroupSelectForDelete($event.value)"
                                    formControlName="groupCode"
                                    (selectionChange)="onDeltGroupSelectionChange($event.value)">
                                    <div *ngIf="locationList.length > 1" class="search_select_container">
    <mat-label>Search Location</mat-label>
    <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
           (input)="searchLocationFromList($event.target.value)"
           autocomplete="off">
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="groupListForDelete.length > 1" value="0"
                                        (click)="allgroupDelTypeSelect()" class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelecteGroupForDelt.length}} of {{groupListForDelete.length}})
                                        </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let c of filteredDelGroupTypeList" [value]="c[0]">
                                            {{c[1]}}
                                        </mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-2 col-sm-6 col-6">
                        <mat-card appearance="outlined" class="contain_card div_spacing">
                            <mat-form-field appearance="fill" class="selectOption">

                                <mat-label>Product SubGroup</mat-label>
                                <mat-select panelClass="custom-select-panel" multiple (openedChange)="onSubGroupSelectForDelete($event.value)"
                                    formControlName="subGroupCode"
                                    (selectionChange)="onDeltSubGroupSelectionChange($event.value)">
                                    <div *ngIf="locationList.length > 1" class="search_select_container">
    <mat-label>Search Location</mat-label>
    <input class="global-input" matInput class=" search_select" (keydown.space)="$event.stopPropagation()"
           (input)="searchLocationFromList($event.target.value)"
           autocomplete="off">
</div>
                                    <hr class="search_select_hr">
                                    <mat-option *ngIf="subGroupListForDelete.length > 1" value="0"
                                        (click)="allSubGroupDelTypeSelect()" class="search_select_checkboxForThird">
                                        Select/Unselect All
                                        <span class="selection-counter">
                                            ({{totalSelecteSubGroupForDelt.length}} of {{subGroupListForDelete.length}})
                                        </span>
                                    </mat-option>
                                    <span class="mat-optoins-container-span">
                                        <mat-option *ngFor="let c of filteredDeSublGroupTypeList" [value]="c[0]">
                                            {{c[1]}}
                                        </mat-option>
                                    </span>
                                </mat-select>
                            </mat-form-field>
                        </mat-card>
                    </div>

                    <div class="col-md-2 col-sm-6 col-6">
                        <button type="submit" class="new_btnStyle global-button" [keyboardShortcut]="viewbtnShortcut"><span
                                class="red_color">V</span>IEW<mat-icon class="icon-style">search</mat-icon>
                        </button>
                    </div>

                </div>

                <div class="shipping_box">
                    <div class="filter_toolbar">
                        <mat-form-field appearance="fill" appearance="fill" class="flex-3">
                            <mat-icon class="white_icon" matTooltip="Filter Columns(Alt+i)">filter_list</mat-icon>
                            <mat-select panelClass="custom-select-panel" multiple (selectionChange)="onColumnSelectForDelete($event.value, true)"
                                ngClass="e-caret-hide" class="filterListSelect" [value]="selectedColumnsForDelete"
                                [keyboardShortcut]="tablefilterShortcut">
                                <mat-option *ngFor="let column of optionalColumnsForDelete" [value]="column">
                                    {{column}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div id="cancel_table-container">
                    <table mat-table class="mat-elevation-z8" [dataSource]="dataSourceForDelete" multiTemplateDataRows>
                        <caption></caption>

                        <ng-container matColumnDef="fromLocation">
                            <th scope="col" mat-header-cell *matHeaderCellDef>From Location</th>
                            <td mat-cell *matCellDef="let element" id="text_align">
                                {{element.fromLocation?.locationName}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="transactionNo">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Transaction No</th>
                            <td mat-cell *matCellDef="let element" id="text_align"> {{element.refNo}}</td>
                        </ng-container>

                        <ng-container matColumnDef="byUser">
                            <th scope="col" mat-header-cell *matHeaderCellDef>By User</th>
                            <td mat-cell *matCellDef="let element" id="text_align">{{element.user.user_Name}} </td>
                        </ng-container>

                        <ng-container matColumnDef="productName">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Product Name</th>
                            <td mat-cell *matCellDef="let element" id="text_align">
                                {{element.productDetail?.product_Name}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="price">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Product Price</th>
                            <td mat-cell *matCellDef="let element" id="number_align">
                                {{element.productDetail?.sale_Price}} </td>
                        </ng-container>

                        <ng-container matColumnDef="weight">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Product Weight</th>
                            <td mat-cell *matCellDef="let element" id="text_align">
                                {{element.weight}} {{element.productDetail?.product_Unit}} </td>
                        </ng-container>

                        <ng-container matColumnDef="batchSize">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Batch Size</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.batchSize}} </td>
                        </ng-container>

                        <ng-container matColumnDef="costOfMaterialBatch">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Cost Of Material Batch
                            </th>
                            <td mat-cell *matCellDef="let element" id="number_align">
                                {{element.costOfMaterialBatch}}</td>
                        </ng-container>

                        <ng-container matColumnDef="costOfPackagingBatch">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Cost Of Packaging Batch
                            </th>
                            <td mat-cell *matCellDef="let element" id="number_align">
                                {{element.costOfPackagingBatch}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="date">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Date</th>
                            <td mat-cell *matCellDef="let element" id="text_align">{{element.date | date :
                                constant.viewDateFormat_DMYHMS}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="productionLoss">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Production Loss</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.productionLoss}} </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="overallCostBatch">
                            <th scope="col" mat-header-cell mat-sort-header *matHeaderCellDef>Total Batch Cost</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.overallCostBatch}} </td>
                            <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"> </td>
                        </ng-container> -->

                        <ng-container matColumnDef="totalMaterialQty">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Total Material Qty</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.totalMaterialQty}} </td>
                        </ng-container>

                        <ng-container matColumnDef="totalPackagingQty">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Total Packaging Qty</th>
                            <td mat-cell *matCellDef="let element" id="number_align">{{element.totalPackagingQty}} </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="totalTime">
                            <th scope="col" mat-header-cell *matHeaderCellDef>Total Time</th>
                            <td mat-cell *matCellDef="let element" id="text_align">{{element.totalTime}}
                                {{element.durationType}}</td>
                        </ng-container> -->

                        <ng-container matColumnDef="delete">
                            <th scope="col" mat-header-cell *matHeaderCellDef> Delete </th>
                            <td mat-cell *matCellDef="let element" (click)="onDeleteRowClick(element.refNo)">
                                <mat-icon>clear</mat-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="viewTableColumnsForDelete; sticky: true"></tr>
                        <tr id="expTableRowHeight" mat-row
                            *matRowDef="let element; columns: viewTableColumnsForDelete;">
                        </tr>
                    </table>
                    <mat-paginator #paginatorForDelete class="mat-paginator-custom" [length]="lengthForDelete"
                        [pageSize]="pageSizeForDelete" (page)="pageEvent = handleViewPageForDelete($event)">
                    </mat-paginator>
                </div>
            </div>

            <div class="custom_sticky_footer">

            </div>
        </form>
    </mat-tab>
</mat-tab-group>